var Slider = require("enyo-ui/Slider"),
    kind   = require("enyo/kind");

require("app/ui/Slider.less");

module.exports = kind(/** @lends  app.ui.Slider.prototype */ {

    /**
     * @private
     */
    name: "app.ui.Slider",

    /**
     * @private
     */
    kind: Slider,

    /**
     * @private
     */
    classes: "app-ui-slider",

    /**
     * Whether to gpu-accelerate this controls' DOM Node.
     *
     * @type     {boolean}
     * @default  true
     * @public
     */
    accelerate: true

});
